import React, {Component} from 'react';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import tableBaseTheme from '../../theme/tableBaseTheme';
import _ from 'lodash';
import { STRIPE_KEY } from 'constants/stripe';
import {StripeProvider, Elements} from 'react-stripe-elements';
import {inject, observer} from 'mobx-react';
import HttpClient from 'services/HttpClient';
import { withRouter } from 'react-router-dom';
import RefreshIcon from '../../../images/RefreshIcon.svg';
import CardForm from './CardForm';

const SUBSCRIPTIONS = '/api/v1/subscriptions';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table';
import moment from 'moment'

const RED = '#E53935';
const YELLOW = '#FBC02D';
const GREEN = '#43A047';
const BLUE = '#0085c5';
const SUBSCRIPTION_CREATE = '/api/v1/subscriptions';
const TOPICS_REQUEST = '/api/v1/tutorials/';

@withRouter
@inject('userStore')
@inject('alertStore')
@inject('topicsStore')
@inject('examPrepHeaderStore')
@observer
class PaymentsSettings extends Component {
  constructor() {
    super();

    this.state = {
      fixedHeader: true,
      stripedRows: false,
      showRowHover: false,
      selectable: true,
      multiSelectable: false,
      enableSelectAll: false,
      deselectOnClickaway: true,
      showCheckboxes: false,
      active: false,
      buttonText: '€ 199 – Purchase',
      payments: [],
      closestCourse: {},
      isStripeOpened: false,
      tutorial_id: null,
      title: 'An'
    };
  }

  handleChange = (event) => {
    this.setState({height: event.target.value});
  };

  onToken = e => {
    const {tutorial_id} = this.state;

    return new HttpClient().post(SUBSCRIPTION_CREATE, {
      token: e.id,
      tutorial_id,
      subs_type: 0
    });
  };

  updatebuttonText = () => {
    let newState = _.assign({}, this.state, {buttonText: 'Pending'});
    this.setState(newState);
  };

  componentWillMount = () => {
    this.refreshPayments();
  };

  refreshPayments = () => {
    const { userStore } = this.props;

    new HttpClient().get(SUBSCRIPTIONS).then(data => {
      if(data.body.data.transctions) {
        this.setState({payments: data.body.data.transctions, active: data.body.data.active});

        if (!userStore.isAdmin()) {
          new HttpClient().get(`${TOPICS_REQUEST}1`).then(data => {
            const topic = data.body.data.tutorial;

            this.props.examPrepHeaderStore.setTopic(topic);
            this.props.userStore.setIsSubscribed(true);
          });
        }
      }
    });
  };

  getColor = type => {
    let color;
    switch(type){
      case 'pending':
        color = YELLOW;
        break;
      case 'success':
        color = GREEN;
        break;
      case 'failed':
        color = RED;
        break;
      case 'refunded':
        color = BLUE;
        break;
    }
    return color;
  };

  handleStripeModal = () => {
    this.setState({isStripeOpened: !this.state.isStripeOpened});
  }

  handleExamStripeModal = tutorial => {
    this.setState({isStripeOpened: !this.state.isStripeOpened, tutorial_id: tutorial.id, title: tutorial.title});
  }

  render() {
    const { closestCourse, isStripeOpened, title } = this.state;
    const { userStore } = this.props;
    const isMobile = window.innerWidth < 568;
    const refreshButtonStyles = isMobile ? {bottom: '-20px'} : {top: 0};

    return (
      <div className="pricing-wrap payments" style={{position: 'relative'}}>
        { _.isEmpty(this.state.payments) ||
        <MuiThemeProvider muiTheme={getMuiTheme(tableBaseTheme)} key={3}>
          <Table
            height={this.state.height}
            fixedHeader={this.state.fixedHeader}
            fixedFooter={this.state.fixedFooter}
            selectable={this.state.selectable}
            multiSelectable={this.state.multiSelectable}
          >
            <TableHeader
              displaySelectAll={this.state.showCheckboxes}
              adjustForCheckbox={this.state.showCheckboxes}
              enableSelectAll={this.state.enableSelectAll}
            >
              <TableRow key='1321'>
                <TableHeaderColumn key={1} style={{width: '35%'}}>Course</TableHeaderColumn>
                <TableHeaderColumn key={2} style={{width: '20%', textAlign: isMobile ? 'center' : 'right'}}>{isMobile ? 'Date' : 'Payment Date'}</TableHeaderColumn>
                <TableHeaderColumn key={2} style={{width: isMobile ? '20%' : '25%'}}>Access Ends</TableHeaderColumn>
                <TableHeaderColumn key={3} style={{width: '10%'}}>Cost</TableHeaderColumn>
                <TableHeaderColumn key={4} style={{width: isMobile ? '15%' : '10%'}}>Status</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              displayRowCheckbox={this.state.showCheckboxes}
              deselectOnClickaway={this.state.deselectOnClickaway}
              showRowHover={this.state.showRowHover}
              stripedRows={this.state.stripedRows}
            >
              {this.state.payments.map((row, index) => (
                <TableRow key={index}>
                  <TableRowColumn key={1} style={{width: '35%'}}>{row.course ? row.course.title : (row.tutorial_title || ('PHARMACIST EXAM PREP'))}</TableRowColumn>
                  <TableRowColumn key={2} style={{width: '20%'}}>{`${moment(row.start_date, 'DD-MM-YYYY').format(isMobile ? 'DD/MM/YY' : 'DD/MM/YYYY')}`}</TableRowColumn>
                  <TableRowColumn key={1} style={{width: isMobile ? '20%' : '25%'}}>{row.end_date ? `${moment(row.end_date, 'DD-MM-YYYY').format(isMobile ? 'DD/MM/YY' : 'DD/MM/YYYY')}` : `${moment(row.start_date, 'DD-MM-YYYY').add(1, 'y').format(isMobile ? 'DD/MM/YY' : 'DD/MM/YYYY')}`}</TableRowColumn>
                  <TableRowColumn key={3} style={{width: '10%'}}>€ {row.amount / 100}</TableRowColumn>
                  <TableRowColumn
                    key={4}
                    style={{
                      width: isMobile ? '15%' : '10%',
                      color: this.getColor(row.status),
                      textTransform: 'capitalize',
                    }}
                  >
                    {row.status}
                    {row.status === 'pending' && (
                      <button
                        className='btn-new-white'
                        style={{
                          ...refreshButtonStyles,
                          position: 'absolute',
                          right: isMobile ? 0 : '-10%',
                          padding: 0,
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                        }}
                        onClick={this.refreshPayments}
                      >
                        <img
                          alt="Refresh"
                          style={{
                            maxHeight: '14px',
                          }}
                          src={RefreshIcon}
                        />
                      </button>
                    )}
                  </TableRowColumn>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </MuiThemeProvider>
          }
        { !closestCourse.is_purchased &&
          <div className="not-payed-wrap">
            {!userStore.isAdmin() ? null : (
              <div className="top-block">
                <div className="desc">An annual subscription costs € 595</div>
              </div>
            )}
            <div className='row'>
              {!userStore.isAdmin() ?
              null : (
                <button className="btn-new-main" onClick={this.handleStripeModal}>{this.state.buttonText}</button>
              )}
            </div>
            {/* </StripeCheckout> */}
          </div>
        }
        <StripeProvider apiKey={STRIPE_KEY}>
          <Elements>
            <CardForm
              onToken={this.onToken}
              cost={this.state.buttonText}
              hideStripeModal={this.handleStripeModal}
              showStripeModal={isStripeOpened}
              email={userStore.user.email}
              title={title}
            />
          </Elements>
        </StripeProvider>
      </div>
    );
  }
}

export default PaymentsSettings;



// WEBPACK FOOTER //
// ./src/modules/profile/components/PaymentsSettings.js